import { types } from 'mobx-state-tree';


const REFERRAL_TYPES = {
    REFERRAL: 'referral',
    ONLINE_SEARCH: 'online-search',
    PAST_CLIENT: 'i-am-a-past-client',
    PARTENAIRE_F: 'partenairef',
    OTHER: 'other',
    RATEHUB: 'ratehub',
};

const ReferralTypeEnum = types.enumeration('ReferralType', Object.values(REFERRAL_TYPES));

export {
    ReferralTypeEnum,
};
export default REFERRAL_TYPES;
